import { render, staticRenderFns } from "./editPrescription.vue?vue&type=template&id=668e3cc7&"
import script from "./editPrescription.vue?vue&type=script&lang=js&"
export * from "./editPrescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports